import { render } from "./AccountPageSkeleton.vue?vue&type=template&id=7736640e&scoped=true"
import script from "./AccountPageSkeleton.vue?vue&type=script&lang=js"
export * from "./AccountPageSkeleton.vue?vue&type=script&lang=js"

import "./AccountPageSkeleton.vue?vue&type=style&index=0&id=7736640e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7736640e"]])

export default __exports__